export const INITIAL_SETUP_OPENED = 'initial-setup-opened';
export const INITIAL_SETUP_INTRODUCTION_BUTTON_CLICKED = 'initial-setup-introduction-button-clicked';
export const INITIAL_SETUP_MEMBERS_SKIP = 'initial-setup-members-skip';
export const INITIAL_SETUP_MEMBERS_ADD_GUEST = 'initial-setup-members-add-guest';
export const INITIAL_SETUP_MEMBERS_REMOVE_GUEST = 'initial-setup-members-remove-guest';
export const INITIAL_SETUP_MEMBERS_SEND_INVITES = 'initial-setup-members-send-invites';
export const INITIAL_SETUP_MEMBERS_SKIP_CONFIRM = 'initial-setup-members-skip-confirm';
export const INITIAL_SETUP_CHATBOT_EDIT = 'initial-setup-chatbot-edit';
export const INITIAL_SETUP_CHATBOT_EDIT_SAVE = 'initial-setup-chatbot-edit-save';
export const INITIAL_SETUP_CHATBOT_SELECT_OPTION = 'initial-setup-chatbot-select-option';
export const INITIAL_SETUP_CHATBOT_SKIP = 'initial-setup-chatbot-skip';
export const INITIAL_SETUP_CHATBOT_CREATE = 'initial-setup-chatbot-create';
export const INITIAL_SETUP_CHATBOT_IMAGE_UPLOAD = 'initial-setup-chatbot-upload-image';
